(() => {
  'use strict';
  if (window.__sentoriseRequestContext) return;
  window.__sentoriseRequestContext = true;
  const lang = (document.documentElement.lang || 'en').slice(0, 2);
  const words = {en: ['Request reference', 'Keep this reference when emailing attachments or following up on your request.', 'Sending…'], de: ['Anfragereferenz', 'Geben Sie diese Referenz an, wenn Sie Anhänge per E-Mail senden oder Rückfragen zu Ihrer Anfrage haben.', 'Wird gesendet…'], fr: ['Référence de la demande', 'Indiquez cette référence lorsque vous envoyez des pièces jointes par e-mail ou faites le suivi de votre demande.', 'Envoi…']}[lang] || ['Request reference', 'Keep this reference when emailing attachments or following up on your request.', 'Sending…'];
  const query = new URLSearchParams(location.search);
  const clean = (value, pattern) => pattern.test(value || '') ? value : '';
  const readStore = key => { try { return JSON.parse(sessionStorage.getItem(key) || 'null'); } catch (_) { return null; } };
  const saveStore = (key, value) => { try { sessionStorage.setItem(key, JSON.stringify(value)); } catch (_) {} };
  function hidden(form, name, value) {
    let field = Array.from(form.elements).find(el => el.name === `contact[${name}]`);
    if (!field) { field = document.createElement('input'); field.type = 'hidden'; field.name = `contact[${name}]`; form.appendChild(field); }
    field.value = value;
  }
  function initForms(scope = document) {
    scope.querySelectorAll('.block-contact-form form').forEach(form => {
      if (form.dataset.sntReady) return;
      form.dataset.sntReady = '1';
      const key = `snt-request:${location.pathname}:${form.id}`;
      const saved = readStore(key);
      const successful = Boolean(form.querySelector('.form-success'));
      const resume = Boolean(successful || form.querySelector('[role="alert"]'));
      const reference = (resume && saved && saved.reference) || (successful ? '' : `SNT-${Date.now().toString(36).toUpperCase()}-${Math.random().toString(36).slice(2, 8).toUpperCase()}`);
      const product = clean(query.get('product'), /^[a-z0-9][a-z0-9-]{0,200}$/) || (resume && saved && saved.product) || '';
      const variant = clean(query.get('variant'), /^\d{1,25}$/) || (resume && saved && saved.variant) || '';
      const model = (query.get('model') || product).slice(0, 240);
      hidden(form, 'request_reference', reference);
      hidden(form, 'product_handle', product);
      hidden(form, 'variant_id', variant);
      hidden(form, 'request_language', document.documentElement.lang || 'en');
      const country = clean(query.get('country'), /^[A-Z]{2}$/);
      if (country) hidden(form, 'destination_country', country);
      hidden(form, 'request_type', location.pathname.split('/').filter(Boolean).pop() || 'contact');
      if (!successful) saveStore(key, {reference, product, variant});
      const modelInput = form.querySelector('input[name*="model"],input[name*="modell"],input[name*="modele"]');
      if (modelInput && !modelInput.value && model) modelInput.value = model;
      const ref = document.createElement('p');
      ref.className = 'snt-request-reference';
      ref.textContent = `${words[0]}: ${reference}. ${words[1]}`;
      const message = form.querySelector('.form-success') || form;
      if (reference) message.appendChild(ref);
      const error = form.querySelector('[role="alert"]');
      if (error) { error.tabIndex = -1; error.focus(); }
      const email = form.querySelector('[data-order-index]');
      const stack = form.querySelector('.contact-form-stack');
      if (stack && email) {
        const children = Array.from(stack.children).filter(el => el !== email);
        const target = children[Math.max(0, Number(email.dataset.orderIndex || 1) - 1)];
        if (target) stack.insertBefore(email, target); else stack.appendChild(email);
      }
      if (successful) { try { sessionStorage.removeItem(key); } catch (_) {} return; }
      form.addEventListener('submit', event => {
        if (event.defaultPrevented || !form.checkValidity()) return;
        if (form.dataset.sntSending === '1') { event.preventDefault(); return; }
        form.dataset.sntSending = '1';
        hidden(form, 'submitted_at_utc', new Date().toISOString());
        form.setAttribute('aria-busy', 'true');
        setTimeout(() => { delete form.dataset.sntSending; form.removeAttribute('aria-busy'); }, 20000);
      });
    });
  }
  document.addEventListener('click', event => {
    const link = event.target.closest && event.target.closest('a[href]');
    if (!link) return;
    let url;
    try { url = new URL(link.href, location.origin); } catch (_) { return; }
    if (url.origin !== location.origin) return;
    if (document.body.classList.contains('template-product') && /\/pages\/(contact|battery-finder|warranty-registration)$/.test(url.pathname)) {
      const handle = location.pathname.split('/products/')[1];
      if (handle) url.searchParams.set('product', handle.split('/')[0]);
      const info = document.querySelector('product-info[data-product-id]');
      const selected = info && info.querySelector('form[action*="/cart/add"] [name="id"]');
      const variant = selected && clean(selected.value, /^\d{1,25}$/);
      if (variant) url.searchParams.set('variant', variant);
      const title = document.querySelector('#MainContent h1');
      if (title) url.searchParams.set('model', title.textContent.trim().slice(0, 240));
    }
    const root = (window.routes && window.routes.root_url) || '/';
    const prefix = root === '/' ? '' : root.replace(/\/$/, '');
    if (prefix && /^\/(pages|products|collections|policies|blogs)(\/|$)/.test(url.pathname)) url.pathname = prefix + url.pathname;
    link.href = url.href;
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initForms()); else initForms();
  document.addEventListener('shopify:section:load', event => initForms(event.target));
  window.addEventListener('pageshow', () => document.querySelectorAll('form[data-snt-sending]').forEach(form => { delete form.dataset.sntSending; form.removeAttribute('aria-busy'); }));
})();

